module.exports = __webpack_public_path__ + "static/media/takenProducts.062e95ea.svg";